<template>
    <div>
        <button
            @click="addItem"
            class="px-4 py-2 bg-green-500 text-white rounded mb-5"
        >
            Tambah TTPP
        </button>
        <div
            v-for="(ttpp, index) in itemList"
            :key="ttpp.ttppUniqueId || index"
            class="ttpp-entry mb-3"
        >
            <div class="lg:w-full md:w-full">
                <div class="flex items-center gap-2">
                    <Dropdown
                        class="w-full"
                        v-model="itemList[index].id"
                        :options="getOptionsForDropdown(index)"
                        optionLabel="fullname"
                        optionValue="id"
                        filter
                        filterBy="fullname"
                        @filter="(event) => fetchOptionsForDropdown(event, index, apiEndpoint)"
                        @change="() => validateUniqueness(index, 'TTPP')"
                        placeholder="Pilih Tim Teknis Perencanaan Pengadaan"
                    />
                    <button
                        @click="removeItem(index)"
                        class="px-4 py-2 bg-red-500 text-white rounded ml-2"
                    >
                        Hapus
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import Dropdown from "primevue/dropdown";
import MultiSelectDropdownMixin from "@/mixins/MultiSelectDropdownMixin.js";

export default defineComponent({
    components: {
        Dropdown,
    },
    mixins: [MultiSelectDropdownMixin],
    props: {
        list_ttpp: Array,
        ttpp_id: String,
    },
    data() {
        // Initialize item list using mixin helper
        const ttppInitialList = this.initializeItemList(
            this.list_ttpp,
            'ttppUniqueId',
            'ttppDisplayIndex'
        );
        
        return {
            // Component-specific configuration
            uniqueIdField: 'ttppUniqueId',
            displayIndexField: 'ttppDisplayIndex',
            apiEndpoint: '/organisasi_pengadaan/search_ttpp',
            
            // Item list management
            itemList: ttppInitialList,
            nextIndex: this.calculateNextIndex(ttppInitialList, 'ttppDisplayIndex'),
        };
    },
    watch: {
        list_ttpp: {
            handler(newValue) {
                if (newValue) {
                    // Block recursive updates
                    if (this._internalUpdate) return;
                    
                    this.itemList = this.initializeItemList(
                        newValue,
                        this.uniqueIdField,
                        this.displayIndexField
                    );
                    
                    this.nextIndex = this.calculateNextIndex(this.itemList, this.displayIndexField);
                    this.updateSelectedItemsCache();
                } else {
                    this.itemList = [];
                    this.nextIndex = 1;
                    this.selectedItemsCache.clear();
                }
            },
            deep: true,
        },
        itemList: {
            handler(newValue) {
                // Prevent recursive updates
                this._internalUpdate = true;
                this.$emit("update:list_ttpp", newValue);
                this.updateSelectedItemsCache();
                this.$nextTick(() => {
                    this._internalUpdate = false;
                });
            },
            deep: true,
        },
    },
    mounted() {
        this.initializeOptions(this.apiEndpoint);
    },
});
</script>
